import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {
  public urlPageRentas: String;
  constructor() {}

  ngOnInit() {
    this.urlPageRentas = environment.settings.urlPageRentas;
  }

}
